import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const AIDA = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14946)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#F4F4F4"
          />
          <rect
            x="81.75"
            y="29.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M138.938 30.2857L82.2858 108.457C82.2858 108.457 82.6837 110.595 83.392 111.366C84.1002 112.138 85.0609 112.571 86.0626 112.571H138.938C139.939 112.571 140.9 112.138 141.608 111.366C142.316 110.595 142.714 109.548 142.714 108.457V34.4C142.714 33.3088 142.316 32.2623 141.608 31.4908C140.9 30.7192 138.938 30.2857 138.938 30.2857Z"
            fill="#E3E3E3"
          />
          <path
            d="M95.1428 48.2856H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 55.9999H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 63.7142H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 71.4285H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 79.1428H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 86.8571H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 94.5714H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="81.75"
            y="29.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M164.404 74.6141L161.998 77.0195L153.981 69.0016L156.386 66.5962C157.455 65.5613 158.888 64.9881 160.376 65.0002C161.864 65.0123 163.287 65.6087 164.339 66.6608C165.391 67.7129 165.988 69.1364 166 70.6242C166.012 72.1121 165.439 73.5451 164.404 74.6141Z"
            fill="#FF808C"
          />
          <path
            d="M145.225 93.7928L134 97L137.207 85.7749L145.225 93.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M153.981 69.0048L137.207 85.7783L145.225 93.7962L161.999 77.0227L153.981 69.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M164.404 74.6141L161.998 77.0195L153.981 69.0016L156.386 66.5962C157.455 65.5613 158.888 64.9881 160.376 65.0002C161.864 65.0123 163.287 65.6087 164.339 66.6608C165.391 67.7129 165.988 69.1364 166 70.6242C166.012 72.1121 165.439 73.5451 164.404 74.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M145.225 93.7928L134 97L137.207 85.7749L145.225 93.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.981 69.0048L137.207 85.7783L145.225 93.7962L161.999 77.0227L153.981 69.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M201.523 13.2129L197.656 25H194.541L199.824 10.7812H201.807L201.523 13.2129ZM204.736 25L200.859 13.2129L200.547 10.7812H202.549L207.861 25H204.736ZM204.561 19.707V22.002H197.051V19.707H204.561ZM212.295 10.7812V25H209.375V10.7812H212.295ZM219.404 25H216.309L216.328 22.7148H219.404C220.173 22.7148 220.82 22.5423 221.348 22.1973C221.875 21.8457 222.272 21.3346 222.539 20.6641C222.812 19.9935 222.949 19.1829 222.949 18.2324V17.5391C222.949 16.8099 222.871 16.1686 222.715 15.6152C222.565 15.0618 222.34 14.5964 222.041 14.2188C221.742 13.8411 221.374 13.5579 220.938 13.3691C220.501 13.1738 220 13.0762 219.434 13.0762H216.25V10.7812H219.434C220.384 10.7812 221.253 10.944 222.041 11.2695C222.835 11.5885 223.522 12.0475 224.102 12.6465C224.681 13.2454 225.127 13.9616 225.439 14.7949C225.758 15.6217 225.918 16.543 225.918 17.5586V18.2324C225.918 19.2415 225.758 20.1628 225.439 20.9961C225.127 21.8294 224.681 22.5456 224.102 23.1445C223.529 23.737 222.842 24.196 222.041 24.5215C221.247 24.8405 220.368 25 219.404 25ZM217.969 10.7812V25H215.039V10.7812H217.969ZM233.613 13.2129L229.746 25H226.631L231.914 10.7812H233.896L233.613 13.2129ZM236.826 25L232.949 13.2129L232.637 10.7812H234.639L239.951 25H236.826ZM236.65 19.707V22.002H229.141V19.707H236.65Z"
            fill="#626266"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14946">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
AIDA.displayName = 'AIDA';
